import { omit } from "lodash"

export default function getNextSortState(state, key) {
    const direction = state[key]
    const nextDirection = direction ? { asc: "desc", desc: null }[direction] : "asc"
    return omit({ ...state, [key]: nextDirection }, !nextDirection ? [key] : [])
}
